import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomInput from "components/CustomInput/CustomInput";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import Modal from "react-responsive-modal";
import { useParams } from "react-router-dom";
import WellnessService from "services/WellnessService";

export default ({ onClose, triviaId }) => {
  const params = useParams();
  const [allQuestions, setAllQuestions] = useState([]);
  const [allCustQuestion, setAllCustQuestion] = useState([]);
  const [customQue, setCustomQue] = useState([]);
  const [activeQue, setActiveQue] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const [customLimitReached, setCustomLimitReached] = useState(false);

  useEffect(() => {
    WellnessService.getAllTriviaQuestions(params.teamId).then((res) => {
      setAllQuestions(
        res.data.questions.map((e) => ({
          ...e,
          options: e.options.map((v) => v.option),
          isCustomCreated: 0,
          correctAnswer: e.answers
            ? e.options.filter((o) => o.id === e.answers.option_id)?.[0]?.option
            : "",
        })) || []
      );
      setAllCustQuestion(
        res.data.customQuestion.map((e) => ({
          ...e,
          name: e.question,
          options: e.options.map((v) => v.option),
          isCustomCreated: 1,
          correctAnswer: e.answers
            ? e.options.filter((o) => o.id === e.answers.option_id)?.[0]?.option
            : "",
        })) || []
      );
    });
  }, [params.teamId]);

  useEffect(() => {
    setCustomLimitReached(false);
  }, [allQuestions, customQue]);

  const isSelected = (item) => {
    const check = customQue.find((e) => e.name === item.name);
    return check ? true : false;
  };

  const handleSelected = (item) => {
    const check = customQue.filter((i) => i.id === item.id);
    if (check.length > 0) {
      setCustomQue((prevState) => {
        const filt = prevState.filter((v) => v.id !== item.id);
        return [...filt];
      });
    } else {
      setCustomQue((prev) => {
        return [...prev, { ...item }];
      });
      setActiveQue(item.id);
    }
  };

  const addCustomQue = () => {
    const tmpId = Math.floor(Date.now());
    if (customQue.length === 0) {
      setCustomQue((prevState) => [
        ...prevState,
        {
          id: tmpId,
          name: "",
          options: ["option 1", "option 2", "option 3", "option 4"],
          isCustomCreated: 1,
          correctAnswer: "option 1",
        },
      ]);
      setActiveQue(tmpId);
    } else if (
      customQue.length > 0 &&
      customQue.filter((e) => e.name === "").length === 0
    ) {
      setCustomQue((prevState) => [
        ...prevState,
        {
          id: tmpId,
          name: "",
          options: ["option 1", "option 2", "option 3", "option 4"],
          isCustomCreated: 1,
          correctAnswer: "option 1",
        },
      ]);
      setActiveQue(tmpId);
    } else {
    }
  };

  const handleTitleChange = (e, queId) => {
    const checkQue = customQue.findIndex((v) => v.id === queId);
    if (checkQue >= 0) {
      setCustomQue((prev) => {
        prev[checkQue].name = e.target.value;
        return [...prev];
      });
    }
  };

  const handleOptionChange = (e, queId, index) => {
    const checkQue = customQue.findIndex((v) => v.id === queId);
    if (checkQue >= 0) {
      setCustomQue((prev) => {
        prev[checkQue].options[index] = e.target.value;
        return [...prev];
      });
    }
  };

  const handleCorrectAns = (opt, queId) => {
    const checkQue = customQue.findIndex((v) => v.id === queId);
    if (checkQue >= 0) {
      setCustomQue((prev) => {
        prev[checkQue].correctAnswer = opt;
        return [...prev];
      });
    }
  };

  const handleSubmit = async () => {
    const payload = {
      triviaId: triviaId,
      teamId: params.teamId,
      questions: customQue
        .filter((e) => e.name !== "" && e.options.filter((e) => e).length === 4)
        .map((item) => {
          return {
            question: item.name,
            isCustomCreated: item.isCustomCreated,
            options: item.options,
            correctAnswer: item.correctAnswer,
          };
        }),
    };

    setSubmitting(true);
    await WellnessService.addTriviaQuestions(payload);
    setSubmitting(false);
    setTimeout(() => onClose(true), 1000);
  };

  return (
    <Modal
      center
      closeOnEsc={false}
      closeOnOverlayClick={false}
      styles={{
        modal: {
          maxWidth: "70%",
          width: "70%",
          borderRadius: "10px",
        },
      }}
      open
      onClose={() => onClose(false)}
    >
      <div className="mt-2">
        <h5>
          <strong>Pick/Add Questions</strong>
        </h5>
        <div className="d-flex">
          <div className="p-2 float-left">
            <ul
              className="list-group"
              style={{
                maxHeight: "300px",
                overflowY: "scroll",
                maxWidth: "400px",
                minWidth: "300px",
              }}
            >
              <h6 class="list-group-item-heading">Standard Questions</h6>
              {allQuestions.map((item) => (
                <li
                  className={`list-group-item ${
                    isSelected(item) ? `active` : ``
                  }`}
                  onClick={() => handleSelected(item)}
                >
                  <div className="d-flex justify-content-between">
                    <div>{item.name}</div>
                  </div>
                </li>
              ))}
              <h6 class="list-group-item-heading">Custom Questions</h6>
              {allCustQuestion.map((item) => (
                <li
                  className={`list-group-item ${
                    isSelected(item) ? `active` : ``
                  }`}
                  onClick={() => handleSelected(item)}
                >
                  <div className="d-flex justify-content-between">
                    <div>{item.name}</div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div className="p-2" style={{ width: "100%" }}>
            <div className="mt-1">
              <button
                className="btn btn-success btn-sm mb-2"
                onClick={addCustomQue}
                disabled={customLimitReached}
              >
                Add Question
              </button>
            </div>
            {customQue.length === 0 && (
              <div className="d-flex justify-content-center mt-3">
                Select questions from provided list or you can create your own
                question by clicking on above button
              </div>
            )}

            <ul className="list-group">
              {customQue.map((item) => (
                <li className="list-group-item">
                  <div className="d-flex align-items-center justify-content-between">
                    <textarea
                      style={{
                        width: "95%",
                        border: "1px solid #e9e9e9",
                        paddingLeft: "5px",
                      }}
                      value={item.name}
                      onChange={(e) => handleTitleChange(e, item.id)}
                      rows={2}
                      disabled={item.isCustomCreated === 0}
                    />
                    <div
                      className="text-danger p-2"
                      onClick={() => handleSelected(item)}
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </div>
                    {item.isCustomCreated !== 0 && (
                      <div onClick={() => setActiveQue(item.id)}>
                        <FontAwesomeIcon icon={faEdit} />
                      </div>
                    )}
                  </div>
                  {item.id === activeQue && (
                    <div className="d-flex flex-column w-50 mt-2">
                      {item.isCustomCreated === 1 ? (
                        item.options.map((opt, iDx) => (
                          <div className="d-flex">
                            <input
                              type="radio"
                              style={{
                                transform: "scale(1.2)",
                                marginRight: "10px",
                              }}
                              checked={item.correctAnswer === opt}
                              name={item.id}
                              onChange={() => handleCorrectAns(opt, item.id)}
                            />
                            <CustomInput
                              inputClass="user-profile-inputs"
                              inputProps={{
                                value: opt,
                                style: { paddingLeft: "5px" },
                              }}
                              onChange={(e) =>
                                handleOptionChange(e, item.id, iDx)
                              }
                            />
                          </div>
                        ))
                      ) : (
                        <div style={{ fontSize: "10px" }}>
                          Options cannot be shown for Pre-Propulated question.
                        </div>
                      )}
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="d-flex justify-content-end">
          <button
            className="btn btn-dark"
            onClick={handleSubmit}
            disabled={submitting || customQue.length === 0}
          >
            Submit
          </button>
        </div>
      </div>
    </Modal>
  );
};
